@let bewe = beweInput();
<div class="flex flex-row justify-between flex-nowrap">
  <div class="flex flex-col">
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.nummer }}</span>
    <span class="text-lg font-semibold">{{
      bewe.artikelMengeOffen.artikel.artbez1
    }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez2 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez3 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez4 }}</span>
    <span class="text-sm color-light">{{ bewe.artikelMengeOffen.artikel.artbez5 }}</span>

    @if (bewe?.artikelMengeOffen?.artikel?.beschreibung | isDefinedNotEmpty) {
      <span
        class="text-sm color-light"
        [innerText]="bewe?.artikelMengeOffen?.artikel?.beschreibung"
      ></span>
    }

    @if (bewe?.dimension && bewe?.dimension?.massUnitId) {
      <span class="italic font-semibold text-sm mt-1"
        >{{ bewe?.dimension?.massUnitId }}: {{ bewe.dimension?.depth }} *
        {{ bewe.dimension?.height }} * {{ bewe.dimension?.width }}</span
      >
    }

    @if ((bewe.zeilentext | isDefined) && bewe.zeilentext !== '') {
      <div
        class="flex flex-row mt-1 items-center"
      >
        <i class="fa-regular fa-circle-info"></i>
        <div class="w-full ml-2" [innerText]="bewe.zeilentext"></div>
      </div>
    }
  </div>

  @if (displayQuantity()) {
    <div class="flex flex-col justify-center items-end">
      <div class="flex flex-row flex-nowrap color-light items-center text-xl">
        <span>{{
          useScannedQuantity()
            ? (bewe?.artikelMengeGescannt?.menge ?? bewe.artikelMengeOffen.menge)
            : bewe.artikelMengeOffen.menge
        }}</span>
        <span class="ml-1">{{
          useScannedQuantity()
            ? (bewe?.artikelMengeGescannt?.einheit?.arteh ??
              bewe.artikelMengeOffen.einheit.arteh)
            : bewe.artikelMengeOffen.einheit.arteh
        }}</span>
      </div>

      @if (bewe.artikelMengeOffen.einheit.id !== bewe.artikelMengeOffen.einheit_lg.id) {
        <div
          class="flex flex-row flex-nowrap color-light items-center text-xl"
        >
        <span class="whitespace-nowrap"
        >=
          {{
            useScannedQuantity()
              ? (bewe?.artikelMengeGescannt?.menge_lg ?? bewe.artikelMengeOffen.menge_lg)
              : bewe.artikelMengeOffen.menge_lg
          }}</span
        >
          <span class="ml-1">{{
              useScannedQuantity()
                ? (bewe?.artikelMengeGescannt?.einheit_lg?.arteh ??
                  bewe.artikelMengeOffen.einheit_lg.arteh)
                : bewe.artikelMengeOffen.einheit_lg.arteh
            }}</span>
        </div>
      }
    </div>
  }
</div>
